<template>
  <v-menu
    ref="menu"
    v-model="showDatePicker"
    :close-on-content-click="false"
    :return-value="date"
    transition="scale-transition"
    offset-y
    min-width="300px"
    class="calendar-v-text-field"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        style="font-size: 0.85rem; width: 65%"
        outlined
        append-icon="fas fa-calendar-day"
        :value="dateString"
        readonly
        v-on="on"
        v-bind="$attrs"
      ></v-text-field>
    </template>
    <v-date-picker
      v-model="date"
      type="month"
      no-title
      scrollable
      :events="eventMonths"
      event-color="green lighten-1"
    >
      <v-spacer></v-spacer>
      <v-btn text color="primary" @click="showDatePicker = false">OK</v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import DatePickerInput from "@/components/DatePickerInput.vue";
import { computed, inject, ref, watch } from "@vue/composition-api";
import { DateTime } from "luxon";

export default {
  name: "NsrPeriodInput",
  components: { DatePickerInput },
  props: {
    value: String,
    min: String,
    max: String,
    eventMonths: Array,
  },
  setup(props, { root, emit }) {
    const date = ref(null);
    watch(
      () => date.value,
      (newValue) => {
        if (newValue) {
          emit(
            "input",
            DateTime.fromFormat(newValue, "yyyy-MM").toFormat("yyyyMM")
          );
        }
      }
    );

    const dateString = computed(() => {
      return props.value ? root.$parsePeriod(props.value) : "";
    });

    const showDatePicker = ref(false);

    return {
      date,
      dateString,
      showDatePicker,
    };
  },
};
</script>
